import { render, staticRenderFns } from "./Affiliate.html?vue&type=template&id=b36022d2&scoped=true&"
import script from "./Affiliate.js?vue&type=script&lang=js&"
export * from "./Affiliate.js?vue&type=script&lang=js&"
import style0 from "./Affiliate.scss?vue&type=style&index=0&id=b36022d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36022d2",
  null
  
)

export default component.exports